import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const PRESET_QUESTIONS = [
  'Would you agree to my invitation?',
  'Would you like to go out with me?',
  'Can I take you somewhere special?',
  'Would you say yes to a date?',
];

const SinglesQuestion = ({ data, onNext }) => {
  const [question, setQuestion] = useState(data.question || PRESET_QUESTIONS[0]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (question.trim()) {
      onNext({ question: question.trim() });
    }
  };

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">The Big Question ❓</h2>
      <p className="text-gray-500 text-sm mb-6">This is what they'll answer with Yes, Maybe, or No</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Your Question</label>
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            rows={3}
            className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none resize-none leading-relaxed text-gray-700 text-center text-lg"
          />
        </div>

        <div>
          <p className="text-xs text-gray-400 font-semibold uppercase mb-2">Or choose a preset</p>
          <div className="space-y-2">
            {PRESET_QUESTIONS.map((q) => (
              <button
                key={q} type="button"
                onClick={() => setQuestion(q)}
                className={`w-full p-3 rounded-xl text-sm text-left transition-all ${
                  question === q
                    ? 'bg-pink-50 border-2 border-pink-500 text-pink-700 font-semibold'
                    : 'bg-gray-50 border-2 border-transparent text-gray-600 hover:bg-gray-100'
                }`}
              >
                {q}
              </button>
            ))}
          </div>
        </div>

        {/* Preview response buttons */}
        <div className="bg-gray-50 rounded-xl p-4">
          <p className="text-xs text-gray-400 font-semibold uppercase mb-3 text-center">They'll see these options</p>
          <div className="flex gap-2">
            <div className="flex-1 bg-green-500 text-white text-center py-2 rounded-lg text-xs font-bold">
              ❤️ Yes
            </div>
            <div className="flex-1 bg-amber-500 text-white text-center py-2 rounded-lg text-xs font-bold">
              🤔 Maybe
            </div>
            <div className="flex-1 bg-gray-400 text-white text-center py-2 rounded-lg text-xs font-bold">
              ❌ No
            </div>
          </div>
        </div>

        <button type="submit" className="w-full bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-pink-200">
          Continue to Preview →
        </button>
      </form>
    </motion.div>
  );
};

export default SinglesQuestion;